module.exports = __webpack_public_path__ + "img/扫描管理@2x.1ed78c1e.png";